(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-skin-tabs-slider"] && !Shopify.designMode) return;
  try {
    
let isSyncing = false;

document.addEventListener("DOMContentLoaded", function () {

  /* ===========================
     MAIN IMAGE SWIPER
  =========================== */

  const swiper = new Swiper(".skinSwiper", {
    centeredSlides: true,
    slidesPerView: 1.4,
    spaceBetween: 50,
    speed: 600,
    loop: true,
    breakpoints: {
      0: {
        loop: false,      
        centeredSlides: true,
        spaceBetween: 20,
      },
      521: {
        loop: false,      
        centeredSlides: true,
        spaceBetween: 30,
      },
      769: {
        loop: true,     
        centeredSlides: true,
        spaceBetween: 50,
      }
    }
  });

  /* ===========================
     MOBILE TAB SWIPER
  =========================== */
  const tabSwiper = new Swiper(".mobile-tabs-swiper", {
    slidesPerView: 1,
    spaceBetween: 20,
    speed: 600,
    loop: false,
    pagination: {
      el: ".mobile-tabs-pagination",
      clickable: true,
    },
  });

  /* ===========================
     SELECT DESKTOP + MOBILE TABS
  =========================== */
  const desktopTabs = document.querySelectorAll(".desktop-tab");
  const mobileTabs = document.querySelectorAll(".mobile-tab");

  /* ===========================
     ACTIVATE TAB FUNCTION
  =========================== */
  function setActiveTab(index) {
    desktopTabs.forEach(t => t.classList.remove("active"));
    mobileTabs.forEach(t => t.classList.remove("active"));

    if (desktopTabs[index]) desktopTabs[index].classList.add("active");
    if (mobileTabs[index]) mobileTabs[index].classList.add("active");

    // Move mobile tab slider
    tabSwiper.slideTo(index);
  }

  /* ===========================
     DESKTOP TAB CLICK
  =========================== */
  desktopTabs.forEach((tab, index) => {
    tab.addEventListener("click", () => {
      isSyncing = true;

      setActiveTab(index);
      swiper.slideToLoop(index);

      setTimeout(() => { isSyncing = false }, 400);
    });
  });

  /* ===========================
     MOBILE TAB CLICK
  =========================== */
  mobileTabs.forEach((tab, index) => {
    tab.addEventListener("click", () => {
      isSyncing = true;

      setActiveTab(index);
      swiper.slideToLoop(index);

      setTimeout(() => { isSyncing = false }, 400);
    });
  });

  /* ===========================
     MAIN SWIPER → UPDATE TABS
  =========================== */
  swiper.on("slideChange", () => {
    if (isSyncing) return;

    isSyncing = true;
    const index = swiper.realIndex;

    setActiveTab(index);
    tabSwiper.slideTo(index);

    setTimeout(() => { isSyncing = false }, 400);
  });

  /* ===========================
     MOBILE TAB SWIPER DRAG → UPDATE IMAGE
  =========================== */
  tabSwiper.on("slideChange", () => {
    if (isSyncing) return;

    isSyncing = true;
    const index = tabSwiper.realIndex;

    setActiveTab(index);
    swiper.slideToLoop(index);

    setTimeout(() => { isSyncing = false }, 400);
  });

  /* SET DEFAULT ACTIVE */
  setActiveTab(0);

});


  } catch(e) { console.error(e); }
})();
})();
